import { useEffect } from 'react';

import { PlanByPlanYear } from '@/modules/HealthPlan/HealthPlan.types';

import { useStore } from '../stores/useCoverageLevels.store';

import useMapAccountFundingConfigs from './useMapAccountFundingConfigs';

/**
 * Centralized sync of plans → accountFundingConfigs for ALL coverage levels.
 * Runs when plans change OR when coverage levels are added/removed.
 *
 * Always re-maps configs to ensure plan metadata (minElectionAmount, maxElectionAmount,
 * planName, perPersonSpendLimitAmount) is up to date — these come from usePlansByPlanYearQuery,
 * not from the initial backend response.
 */
const useSyncAccountFundingConfigs = (
  plans: PlanByPlanYear[],
  isTemplateMode?: boolean,
  isLoading?: boolean
) => {
  const { mapPlansToConfigs } = useMapAccountFundingConfigs();

  const coverageLevelCount = useStore((state) => state.state.length);
  useEffect(() => {
    if (isTemplateMode || isLoading) return;

    const { state, setState } = useStore.getState();
    if (!state.length || !plans.length) return;

    const updatedState = state.map((item) => ({
      ...item,
      accountFundingConfigs: mapPlansToConfigs(plans, item.accountFundingConfigs),
    }));

    setState(updatedState);
  }, [plans, isTemplateMode, isLoading, mapPlansToConfigs, coverageLevelCount]);
};

export default useSyncAccountFundingConfigs;
